import React from 'react'
import { Link } from 'react-router-dom';
import { PencilIcon, GridThreeUpIcon } from 'react-open-iconic-svg';
import Expert                         from 'services/Expert';
import { expertSearchStatePropTypes } from 'services/constants';

import AbstractSearchableList from 'components/AbstractSearchableList';
import SearchFormComponent from 'components/ExpertSearchForm';
import RemoveButton        from 'components/RemoveButton';

function ItemComponent({ item, collectionName, onRemove }) {
  function removeItem() {
    onRemove(item);
  }
  return (
    <div id={item.id} className="row border rounded pt-1 pb-1 mb-1">
      <div className="col-1">
        <Link to={`/${collectionName}/${item.id}`} className="me-3 btn btn-info" title="редактировать">
          <PencilIcon className="icon" viewBox="0 0 8 8" alt="редактировать" />
        </Link>
        <Link to={`/${collectionName}/${item.id}/breeds`} className="me-1 btn btn-light" title="породы">
          <GridThreeUpIcon className="icon" viewBox="0 0 8 8" alt="породы" />
        </Link>  
      </div>
      <div className="col-10 col-md-6">
        <h5>{item.name} <small className="ms-2">{item.email}</small></h5>
        <div>{item.fullAddress()}</div>
        <div>FCI группы: {item.fci_groups.join(', ')}</div>
      </div>
      <RemoveButton className="col-1 btn-sm float-end ms-2" remove={removeItem} />
    </div>
  );
}


export default class Experts extends AbstractSearchableList {

  constructor(props) {
    super(props);
    this.itemClass = Expert;
    this.itemName = 'expert';
    this.collectionName = 'experts';
    this.collectionNameHuman = 'Эксперты';
    this.Item = ItemComponent;
    this.SearchForm = SearchFormComponent;
    this.searchStatePropTypes = expertSearchStatePropTypes;
  }

}
